import { ImageCollection } from '@base/features/image/imageProvider';

const BASE_PATH = `assets/images/`;

export type BackgammonImageCollectionKeys =
  | 'CheckerBlack'
  | 'CheckerWhite'
  | 'LineDarkGreen'
  | 'LineLightGreen'
  | 'LineMove'
  | 'LineUndo'
  | 'Dot'
  | 'Board'
  | 'DoubleCubeBlack'
  | 'DoubleCubeWhite'
  | 'DoubleCubeGray'
  | 'DoubleCubeBlackActive'
  | 'DoubleCubeWhiteActive'
  | 'DoubleCubeGrayActive'
  | 'BarImage'
  | 'Dice1'
  | 'Dice2';

const BG_IMAGE_COLLECTION: ImageCollection<BackgammonImageCollectionKeys> = [
  { name: 'CheckerBlack', path: 'checkers/checker_black.png', dynamic: true },
  { name: 'CheckerWhite', path: 'checkers/checker_white.png', dynamic: true },
  { name: 'LineDarkGreen', path: 'triangles/triangle_brown.png', dynamic: true },
  { name: 'LineLightGreen', path: 'triangles/triangle_yellow.png', dynamic: true },
  { name: 'LineMove', path: 'triangles/triangle_move.png', dynamic: true },
  { name: 'LineUndo', path: 'triangles/triangle_undo.png', dynamic: true },
  { name: 'Dot', path: 'dots/dot.png', dynamic: true },
  { name: 'Board', path: 'board/board.png', dynamic: true },
  { name: 'DoubleCubeBlack', path: 'double_cube/double_black.png', dynamic: true },
  { name: 'DoubleCubeWhite', path: 'double_cube/double_white.png', dynamic: true },
  { name: 'DoubleCubeGray', path: 'double_cube/double_gray.png', dynamic: true },
  { name: 'DoubleCubeBlackActive', path: 'double_cube/double_black_active.png', dynamic: true },
  { name: 'DoubleCubeWhiteActive', path: 'double_cube/double_white.png', dynamic: true },
  { name: 'DoubleCubeGrayActive', path: 'double_cube/double_gray.png', dynamic: true },
  { name: 'BarImage', path: 'gameboard/bar.png', dynamic: true },
  { name: 'Dice1', path: `dice-sprites/dice1.png` },
  { name: 'Dice2', path: `dice-sprites/dice2.png` },
];

export { BASE_PATH, BG_IMAGE_COLLECTION };
